const layers = {
  base: 0,
  stage: 100,
  pane: 200,
  drawer: 300,
  dock: 400,
  flyout: 500,
  dialog: 600,
  overlay: 700,
  tooltip: 800,
  alert: 900,
} as const;

export const zIndexes = {
  // Base
  base: layers.base,

  // Stage
  stage: layers.stage,

  // Panes
  pane: layers.pane,
  paneDrawer: layers.pane + 1,
  paneStuck: layers.pane + 2,

  // Drawer
  drawer: layers.drawer,
  drawerContent: layers.drawer + 1,
  drawerWash: layers.drawer - 1,

  // Dock
  dock: layers.dock,
  dockCore: layers.dock + 1,
  dockSidebar: layers.dock - 1,

  // Flyouts
  flyout: layers.flyout,

  // Minimizer
  minimizer: layers.flyout + 1,

  // Dialogs
  dialog: layers.dialog,
  dialogContent: layers.dialog + 1,
  dialogWash: layers.dialog - 1,

  // Overlays
  overlay: layers.overlay,
  overlayContent: layers.overlay + 1,
  overlayWash: layers.overlay - 1,

  // Tooltips
  tooltip: layers.tooltip,

  // Alerts
  alert: layers.alert,
};
